// extracted by mini-css-extract-plugin
export default {"burger":"burger_burger__DjmGe","burger__menu":"burger_burger__menu__FMgQp","burger__nav":"burger_burger__nav__KoFSU","ant-modal-header":"burger_ant-modal-header__axs5N"};